import { IAppState } from '../common/state';

export function selectIsSerpFetching(state: IAppState): boolean {
  return state.isFetching;
}
